export const PayPeriodLockedActionTypeEnum = {
  CREATE_EDIT_AND_DELETE: "create_edit_and_delete",
  APPROVAL_AND_UNAPPROVAL: "approval_and_unapproval",
};
export const PayPeriodLockedActionTypeArray = Object.values(PayPeriodLockedActionTypeEnum);
export type PayPeriodLockedActionType = (typeof PayPeriodLockedActionTypeArray)[number];

export const PayPeriodLockResourceTypeEnum = {
  TIMESHEET: "timesheet",
  TIME_OFF_REQUEST: "time_off_request",
  REIMBURSEMENT: "reimbursement",
};
export const PayPeriodLockResourceTypeArray = Object.values(PayPeriodLockResourceTypeEnum);
export type PayPeriodLockResourceType = (typeof PayPeriodLockResourceTypeArray)[number];

export type PayPeriodLockSettings = {
  post_period_lock_hours?: number | null;
  team_member_ids_to_notify: string[];
  lock_types: PayPeriodLockResourceType[];
  locked_action_types: PayPeriodLockedActionType[];
};
